<template>
  <div class="about">
    <div>
      <v-btn text v-on:click="navigateRoute('/category/eventphotolist/' + eventData.CategoryID)">Back</v-btn>
    </div>
    <h1>{{ eventData.Name }}</h1>
    <v-row>
      <v-col cols="12" sm="6" offset-sm="3">
        <v-dialog v-model="showGalleryDialog" dark fullscreen>
          <v-card>
            <v-toolbar dark>
              <v-btn icon dark v-on:click="showGalleryDialog = false">
                <v-icon>close</v-icon>
              </v-btn>
              <v-toolbar-title>photos</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items></v-toolbar-items>
            </v-toolbar>
            <v-layout justify-center>
              <v-img :src="currentURL" :height="windowHeight" :max-width="windowWidth" contain></v-img>
            </v-layout>
            <v-card-actions>
              <v-btn text v-on:click="loadprevious()">
                <v-icon>arrow_back</v-icon>
              </v-btn>
              <v-img :src="getPreviousURL" height="1" width="1" v-show="false"></v-img>
              <v-spacer></v-spacer>
              <v-btn text v-on:click="downloadFile()">Download</v-btn>
              <v-spacer></v-spacer>
              <v-img :src="getNextURL" height="1" width="1" v-show="false"></v-img>
              <v-btn text v-on:click="loadnext()">
                <v-icon>arrow_forward</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-card>
          <v-container fluid class="px-5">
            <v-row>
              <v-col v-for="picture in pictures" :key="picture.id" class="d-flex child-flex pa-1" cols="3">
                <v-card flat tile class="d-flex" v-on:click="showCarouselPictures(picture.index)">
                  <v-img :src="picture.url" aspect-ratio="1" class="grey lighten-2">
                    <template v-slot:placeholder>
                      <v-row fill-height align-center justify-center ma-0>
                        <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "EventPhoto",
  props: {
    id: {
      type: String,
      default: "1"
    }
  },
  computed: {
    windowWidth: function () {
      return window.innerWidth;
    },
    windowHeight: function () {
      return 0.8 * window.innerHeight;
    },
    previewWindowHeight: function () {
      return 0.1 * window.innerHeight;
    },
    getPreviousURL: function () {
      let previousURLIndex = this.carouselIndex - 1;
      if (previousURLIndex < 0) {
        previousURLIndex = this.carouselpictures.length - 1;
      }
      if (this.carouselpictures[previousURLIndex]) {
        return this.carouselpictures[previousURLIndex].url;
      }
      return "";
    },
    getNextURL: function () {
      let nextURLIndex = this.carouselIndex + 1;
      if (nextURLIndex == this.carouselpictures.length) {
        nextURLIndex = 0;
      }
      if (this.carouselpictures[nextURLIndex]) {
        return this.carouselpictures[nextURLIndex].url;
      }
      return "";
    }
  },
  data() {
    return {
      eventData: {
        ID: 0,
        CreatedAt: "2019-06-15T02:18:04.600131+08:00",
        EditedAt: "2019-06-15T02:18:04.600131+08:00",
        DeletedAt: "",
        Name: "",
        Category: {},
        CategoryID: {},
        Author: {},
        AuthorID: 0,
        ScriptureReference: "",
        Details: ""
      },
      pictureEntries: [],
      pictures: [],
      carouselpictures: [],
      showGalleryDialog: false,
      currentURL: "",

      carouselIndex: 0
    };
  },
  created() {
    this.initialize();
  },
  methods: {
    initialize() {
      this.pictureEntries = [];
      axios
        .get("/api/content/event/" + this.id + "/mediaentrylist")
        .then(response => {
          this.pictureEntries = response.data;
          this.pictures = this.pictureEntries.map(x => ({
            id: x.Index,
            index: x.Index,
            url: x.ThumbnailUrl
          }));
          this.carouselpictures = this.pictureEntries.map(x => ({
            id: x.Index,
            index: x.Index,
            url: x.Url
          }));
          for (let i = 0; i < this.pictureEntries.length; i++) {
            this.pictures[i].id = i;
            this.pictures[i].index = i;
            this.carouselpictures[i].id = i;
            this.carouselpictures[i].index = i;
          }
        })
        .catch(() => { });
      axios
        .get("/api/content/event/" + this.id)
        .then(response => {
          this.eventData = response.data;
        })
        .catch(() => { });
    },
    navigateRoute: function (newpath) {
      this.$router.push(newpath, () => { });
    },
    loadCarouselPictures(index) {
      this.carouselIndex = index;
      this.currentURL = this.carouselpictures[index].url;
    },
    showCarouselPictures(index) {
      this.loadCarouselPictures(index);
      this.showGalleryDialog = true;
    },
    loadprevious() {
      this.carouselIndex = this.carouselIndex - 1;
      if (this.carouselIndex < 0) {
        this.carouselIndex = this.carouselpictures.length - 1;
      }
      this.currentURL = this.carouselpictures[this.carouselIndex].url;
    },
    loadnext() {
      this.carouselIndex = this.carouselIndex + 1;
      if (this.carouselIndex == this.carouselpictures.length) {
        this.carouselIndex = 0;
      }
      this.currentURL = this.carouselpictures[this.carouselIndex].url;
    },
    downloadFile() {
      axios({
        url: this.currentURL,
        headers: {
          "Cache-Control": "no-cache",
          Authorization: ""
        },
        method: "GET",
        responseType: "blob" // important
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        let filename = this.currentURL.substring(
          this.currentURL.lastIndexOf("/") + 1,
          this.currentURL.length
        );
        link.setAttribute("download", filename); //or any other extension
        document.body.appendChild(link);
        link.click();
      });
    }
  }
};
</script>

<style>
.v-window__container--is-active {
  height: 100% !important;
}

.v-card__text,
.v-card__title {
  word-break: normal;
}
</style>
